import { prepareCommonFileUpload, putToPresignedUrl } from '@/services/commonFile/apis'

/**
 * 게시판 첨부 업로드 — 공통 파일 API 업로드 준비 + S3 PUT 만 하고 키를 돌려준다. 키는 글 저장 요청 `attachmentKeys` 에 싣는다.
 * 완료 처리(PATCH)는 반품 테이블(`IIF_MOMSAN_TYPE1`) 전용이라 부르지 않는다(LOGISPRD-16201 결정).
 *
 * @param shipper 글 화주 — 서버가 키를 `{env}/{글 화주}/` 로 검증한다. 일반 글은 소속 화주, 공지는 공지 대상(`ALL` 또는 화주)
 */
export const uploadBoardAttachment = async (shipper: string, file: File): Promise<string> => {
  const { key, uploadUrl, signedHeaders } = (await prepareCommonFileUpload('RP14', shipper, file.name, file.type || 'application/octet-stream'))
    .data
  await putToPresignedUrl(uploadUrl, file, signedHeaders)
  return key
}
